import SortOrder from 'sharedreact/data/SortOrder';
import AppDispatcher from 'sharedreact/dispatcher/AppDispatcher';
import ItemsStore from 'sharedreact/stores/generic/ItemsStore';

import OpenIDConfigActions from 'workspaces/launcher/actions/OpenIDConfigActions';
import OpenIDConfigConstants from 'workspaces/launcher/constants/OpenIDConfigConstants';
import type OpenIDConfig from 'workspaces/launcher/data/OpenIDConfig';

function _sortOidcConfig (openIDConfig1: OpenIDConfig, openIDConfig2: OpenIDConfig): number {
  const firstFileName: string = openIDConfig1.name.toLowerCase() + '.xml';
  const secondFileName: string = openIDConfig2.name.toLowerCase() + '.xml';
  return firstFileName === secondFileName ? 0 : firstFileName < secondFileName ? -1 : 1;
}

class OpenIDConfigsStore extends ItemsStore<OpenIDConfig> {
  constructor () {
    super(AppDispatcher, OpenIDConfigActions, OpenIDConfigConstants);
  }

  _getCompareFunction (sortOrder: SortOrder): (a: OpenIDConfig, b: OpenIDConfig) => number {
    return _sortOidcConfig;
  }
}

export default new OpenIDConfigsStore();
